import React from 'react';

import HeaderLogoAndDropDown from './HeaderLogoAndDropDown';


class AnchorPortalHeader extends React.Component {

  render() {
    const { handleClick } = this.props;

    return (
      <div id="anchor-portal-header">
        <HeaderLogoAndDropDown
          isAnchorPortal={true}
          toggleMobileHeader={handleClick}
        />
      </div>
    );
  }
}

export default AnchorPortalHeader;
